import { subscribeKey } from "valtio/utils";

import blitzMessage, { EVENTS } from "@/__main__/ipc-core.mjs";
import { THEME_DARK } from "@/app/constants.mjs";
import lolRefs from "@/game-lol/refs.mjs";
import { changeLanguage } from "@/i18n/i18n.mjs";
import { devError } from "@/util/dev.mjs";
import globals from "@/util/global-whitelist.mjs";
import subscriptionStateDiff from "@/util/subscription-state-diff.mjs";
import themes from "@/util/themes.mjs";

let unsubscribeSettings;

export function registerSettingsSubscriptions(readState) {
  unsubscribeSettings = subscribeKey(
    readState,
    "settings",
    subscriptionStateDiff(onSettingsChange, readState.settings),
  );

  // Initial register of lol settings to s2 observable
  setLOLInGameSettings(readState.settings.lol);
}

export function unregisterSettingsSubscriptions() {
  if (unsubscribeSettings) unsubscribeSettings();
}

function onSettingsChange(nextSettings, prevSettings) {
  if (!prevSettings || !nextSettings) return;

  if (prevSettings.selectedLanguage !== nextSettings.selectedLanguage) {
    setLanguage(nextSettings.selectedLanguage);
  }

  setLOLInGameSettings(nextSettings.lol);
  setThemeStyle(nextSettings.theme);
}

function setThemeStyle(theme = THEME_DARK) {
  const themeObj = themes[theme];
  if (!themeObj) return;
  const { cssClass: addedClass } = themeObj;

  // first reset existing classes
  for (const { cssClass } of Object.values(themes)) {
    globals.document.body.classList.remove(cssClass);
  }

  globals.document.body.classList.add(addedClass);
}

function setLanguage(language) {
  blitzMessage(EVENTS.CHANGE_LANGUAGE, language).catch((error) => {
    devError("Failed to set language", error);
  });

  changeLanguage(language);
}

async function setLOLInGameSettings(settings) {
  if (!lolRefs.inGameState) return;
  const { ref } = await import("s2-engine");
  lolRefs.inGameState.settings = ref(settings);
}
